import React from "react";
import Marquee from "react-fast-marquee";

const Footer = () => {
	return <div className="footer">
		<Marquee style={{ width: '100%', height: '100%' }}>
			&#169; Made by CodeWizard_26
		</Marquee>
	</div>;
};

export default Footer;
